/**
 * Token Manager Utility
 * Manages JWT tokens in localStorage
 * Matches the structure from the existing web app
 */

const ACCESS_TOKEN_KEY = 'versus_admin_access_token';
const REFRESH_TOKEN_KEY = 'versus_admin_refresh_token';
const EMAIL_KEY = 'versus_admin_email';

export const tokenManager = {
  saveTokens: (accessToken: string, refreshToken: string, email: string) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    localStorage.setItem(EMAIL_KEY, email);
  },

  getAccessToken: (): string | null => {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  getRefreshToken: (): string | null => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  getEmail: (): string | null => {
    return localStorage.getItem(EMAIL_KEY);
  },

  clearTokens: () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(EMAIL_KEY);
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem(ACCESS_TOKEN_KEY);
  },
};

